// extracted by css-extract-rspack-plugin
export default {"overlay":"g3312uFYo4X_XhGw"};